import { SHOW_SIGN_IN_MODAL, HIDE_SIGN_IN_MODAL, SHOW_EMAIL_VERIFICATION, SHOW_FIRST_SIGN_IN, SHOW_SIGN_IN, SHOW_SIGN_UP, SHOW_FORGOT_PASSWORD, SHOW_EMAIL_SENT } from '../constants/action_types';

const showSignInModal = (targetUrl = null) => ({
    type: SHOW_SIGN_IN_MODAL,
    targetUrl
});

const hideSignInModal = () => ({
    type: HIDE_SIGN_IN_MODAL
});

const showEmailVerification = (data) => ({
    type: SHOW_EMAIL_VERIFICATION,
    data
});

const showFirstSignIn = (data) => ({
    type: SHOW_FIRST_SIGN_IN,
    data
});

const showSignIn = (data) => ({
    type: SHOW_SIGN_IN,
    data
});

const showSignUp = (data) => ({
    type: SHOW_SIGN_UP,
    data
});

const showForgotPassword = (data) => ({
    type: SHOW_FORGOT_PASSWORD,
    data
});

const showEmailSent = (data) => ({
    type: SHOW_EMAIL_SENT,
    data
});

export {
    showSignInModal,
    hideSignInModal,
    showEmailVerification,
    showFirstSignIn,
    showSignIn,
    showSignUp,
    showForgotPassword,
    showEmailSent
};
